export const NotFound = () => {
  return <h1>This is page not found</h1>;
};
